<template>
  <div>
    <div className="container">
      <div class="footer-nav mx-0">
        <router-link :to="'/group'">
          <span class="footer-nav-link footer-nav-left text-muted">
            <i class="el-icon-arrow-left"></i>
            返回
          </span>
        </router-link>
      </div>
      <div>
        <main-menu type="0"></main-menu>
      </div>
      <div className="row">
        <div className="col-sm-9 col-12  border-none pt-0 bglight mt-2">
          <div
              v-infinite-scroll="loadApplyList"
              infinite-scroll-disabled="disabled"
              infinite-scroll-distance="50">
            <div v-if="userlist==''" style="height: 146px;width: 991px;padding-top: 55px;" class="bg-white text-center">
              目前还没有 新的申请人
            </div>
            <div v-else className="row row-cols-1 row-cols-sm-2 row-cols-md-3 bg-none"
                 v-for="item in userlist"
                 :key="item.id">
              <div class="mx-0 d-flex bg-content">
                <div class="ml-3 flex-fill " style="line-height:48px">

                    <h3 class="mb-1"> {{ item.name }}群</h3>

                  <li class="row py-2" style="border-top: 1px solid #eee;font-size: 20px" v-for="items in item.apply_userID" :key="items.id">
                    <a slot="reference" class="mr-3"
                       :href="'https://passport.wenxuecity.com/members/index.php?act=profile&cid='+items.username">
                    {{ items.username }}
                     </a>
                          申请成为
                    <router-link :to="'/group/index/'+item.id" class="mx-3">  {{ item.name }}群   </router-link>  管理员
                    <span class="ml-auto">

                              <el-button style="font-size: 18px" class="ml-3 mr-2" type="danger" plain round size="medium"
                                         @click="apply_user_delete(item.id,items.id)">拒绝
                              </el-button>
                              <el-button style="font-size: 18px" class="ml-4" type="success" plain round size="medium"
                                         @click="apply_user_add(item.id,items.id)">批准
                              </el-button>
                     </span>
                  </li>
                </div>
              </div>
            </div>
          </div>
          <div className="text-center py-5" v-if="loading.article"><!-- loader -->
            <i className="now-ui-icons loader_refresh spin"></i>
          </div>
          <!--          <p className="text-center py-4 nomore" v-if="noMore">&#45;&#45; 没有更多内容 &#45;&#45;</p>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import icons from "@/components/Icons/Icons";
import MainMenu from '@/module/group/pages/components/Main/MainMenu';
import group from '@/module/group/group.service';
export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    MainMenu,
  },
  created() {
    this.loadApplyList();
    console.log(this)
  },
  methods: {
    loadApplyList() {
      this.loading = true;
      group.apply_user_list(this.LastID).then(res => {
        if (res.status) {
          let arr = res.data;
          this.noMore = arr.length < 19 ? true : false;
          this.LastID = arr[arr.length - 1]['lastID']
          this.userlist = this.userlist.concat(arr);
          this.loading= false;
        }
      })
    },
    // $store.state.group.groupTopBar.auth>1
    // $store.state.group.groupTopBar.auth=2
    apply_user_add(groupinfoID,userID){
      group.apply_user_add(groupinfoID, userID).then(res => {
          if (res.status) {
            console.log(1)
            console.log(2)
            this.loadApplyList();
            this.$store.dispatch('group/getGroupTopBar', this.groupID);
            this.$message.success('已批准成功!');
            setTimeout(()=>{
              location. reload();
            },1000)
        } else {
          this.$message.warning(res.error);
        }
      })
    },
    apply_user_delete(groupinfoID,userID) {
      group.apply_user_delete(groupinfoID, userID).then(res => {
        if (res.status) {
          console.log(1)
          console.log(2)
          this.loadApplyList();
          this.$message.success('已拒绝!');
          setTimeout(()=>{
            location. reload();
          },1000)
          this.$store.dispatch('group/getGroupTopBar', this.groupID);
        } else {
          this.$message.warning(res.error);
        }
      })
    },

  },
  data() {
    return {
      user: this.$store.state.user,
      noMore: false,
      LastID: 0,
      loading:  true,
      userlist: [],
    };
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    }
  }
};
</script>
<style>
.el-button--success.is-plain:focus, .el-button--success.is-plain:hover {
  background: #67C23A!important;
  border-color: #67C23A!important;
  color: #FFF;
}
.bglight {
  background: #f6f6f6 !important
}

.nomore {
  text-align: center;
  margin: 20px 0;
  font-size: 16px;
  color: #838383;
}
</style>
